/**
 * The Community's sub-tabs and their ?tab= (walk 3 #5, 2026-10-28). One place
 * says how the page's state reads in the URL and back, so the Voice view's own
 * tab buttons, MysticCommunity's tabs and the URL never disagree.
 *   communityTab: 'home' (Mystics) | 'seekers' (Lessons); Voice is the pulse view.
 *   ?tab=: 'mystics' | 'fireside' | 'voice'.
 */
export function communityTabFor(view) {
  return view === 'seekers' ? 'seekers' : 'home'
}

export function communitySlug({ voice = false, tab = 'home' } = {}) {
  if (voice) return 'voice'
  return tab === 'seekers' ? 'fireside' : 'mystics'
}
